var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9565 22.7826H27",
    stroke: "#0068B5",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 29.7391H20.0435",
    stroke: "#0068B5",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3477 36.6957H24.3911",
    stroke: "#0068B5",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3479 12.3478H27.8696V8.86951H36.5653V12.3478H33.087",
    stroke: "#0068B5",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9564 14.0869V15.9304C41.7825 16.8 47.8695 23.426 47.8695 31.4782C47.8695 40.1217 40.8608 47.1304 32.2173 47.1304H19.1738",
    stroke: "#0068B5",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6606 39.3043C19.6867 41.0782 21.0433 42.6261 22.6519 43.8695",
    stroke: "#0068B5",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5913 32.3478C16.6696 33.8434 16.9652 35.2782 17.4348 36.6347",
    stroke: "#0068B5",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7911 25.3914C17.2172 26.7566 16.8259 28.2087 16.6606 29.7392",
    stroke: "#0068B5",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4782 14.0869V15.9304C25.7651 16.4521 21.6782 19.0695 19.1738 22.826",
    stroke: "#0068B5",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2171 34.0869C33.6578 34.0869 34.8258 32.9189 34.8258 31.4782C34.8258 30.0375 33.6578 28.8695 32.2171 28.8695C30.7764 28.8695 29.6084 30.0375 29.6084 31.4782C29.6084 32.9189 30.7764 34.0869 32.2171 34.0869Z",
    stroke: "#0068B5",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9565 29.7391L40.9131 22.7826",
    stroke: "#0068B5",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9998 18.4347L44.3911 15.826",
    stroke: "#0068B5",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6523 20.1739L45.261 17.5652",
    stroke: "#0068B5",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7653 25.3914C43.8001 27.1827 44.3914 29.2609 44.3914 31.4783C44.3914 38.2001 38.9393 43.6522 32.2175 43.6522H28.7393",
    stroke: "#0068B5",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4349 47.1305H15.6958",
    stroke: "#0068B5",
    strokeWidth: 1.73913,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.7391,
    height: 40,
    fill: "white",
    transform: "translate(7 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerformance);
export default __webpack_public_path__ + "static/media/icon_performance.d2229e7e04ae5a961250c95dfe176c19.svg";
export { ForwardRef as ReactComponent };